import React, {useCallback, useState} from 'react';
import {
  Grid,
  TextField,
} from '@material-ui/core';
import useDebounce from 'hooks/UseDebounce';
import Brands from './brands';


const browseBrandsTreatments = ({results}) => {
  const [searchBrands, setSearchBrands] = useState('');
  const brandsType = 'treat';
  const handleChange = useCallback((event) => {
    setSearchBrands((event.target.value).toLowerCase());
  }, []);

  const debouncedSearchBrands = useDebounce(searchBrands, 300);

  return (
    <div>
      <Grid item xs={12} className="flex justify-between items-center mb-12">
        <TextField
          label="Search Brand..."
          variant="outlined"
          className="w-full"
          style={{maxWidth: '300px'}}
          onChange={handleChange}
          id="back-to-top-anchor"
        />
      </Grid>
      <Brands results={results} debouncedSearchItem={debouncedSearchBrands} brandsType={brandsType} />
    </div>
  );
};

export default browseBrandsTreatments;
